export default function whenValueChanges(evaluation, callback) {
    let originalValue = evaluation();

    return function() {
        let changedValue = evaluation();
        if (changedValue === originalValue) {
            return;
        }

        originalValue = changedValue;
        callback(changedValue);
    };
}
